<template>
  <div>
    <h3 class="page-title">ئوقۇتقۇچى باشقۇرۇش</h3>
    <el-divider></el-divider>
    <!-- <el-row class="rtl-right">
      <el-button type="primary" plain icon="el-icon-circle-plus-outline" v-if="pageTags.create" @click="add">قوشۇش </el-button>
    </el-row> -->
    <!-- table-box -->
    <div class="table-box teachers-table" v-if="pageTags.list">
      <el-table
        :data="tableData" 
        border 
        style="width: 100%" 
        v-loading="loading">
        <!-- <el-table-column type="expand">
          <template slot-scope="props">
            <p class="mytitle mytitle-ug">چۈشەندۈرلىشى  (ئۇيغۇرچە):</p>
            <div v-html="props.row.description_ug" class="mycontent mycontent-ug"></div>
            <el-divider></el-divider>
            <p class="mytitle mytitle-zh">描述（中文）:</p>
            <div v-html="props.row.description_zh" class="mycontent"></div>
          </template>
        </el-table-column> -->
        <el-table-column prop="image" label="باش سۈرەت" width="110">
          <template slot-scope="scope">
            <img :src="scope.row.image" class="table-img">
          </template>
        </el-table-column>
        <el-table-column prop="name_ug" label="ئوقۇتقۇچى (ئۇيغۇرچە)"></el-table-column>
        <el-table-column prop="user.uid" label="uid"></el-table-column>
        <el-table-column prop="user.name" label="ئىسمى"></el-table-column>
        <!-- <el-table-column prop="name_zh" label="ئوقۇتقۇچى (خەنزۇچە)"></el-table-column> -->
        <!-- <el-table-column prop="phone" label="تېلېفون"></el-table-column> -->
        <el-table-column prop="percent" label="باشقىلار دەرس ساتقاندىكى پىرسەنت"></el-table-column>
        <el-table-column prop="own_percent" label="ئوقۇتقۇچى ئۆزى ساتقاندىكى پىرسەنت"></el-table-column>
        <el-table-column prop="order" label="تەرتىپى"></el-table-column>
        <el-table-column prop="view_count" label="ئاۋاتلىقى" sortable></el-table-column>
        <el-table-column prop="recommend" width="120" label="تەۋسىيە">
          <template slot-scope="scope">
            <label v-show="scope.row.recommend==1">ھەئە</label>
            <label v-show="scope.row.recommend==0">ياق</label>
          </template>
        </el-table-column>
        <el-table-column prop="status" width="120" label="ھالەت">
          <template slot-scope="scope">
            <label v-show="scope.row.status==1">ئوچۇق</label>
            <label v-show="scope.row.status==0">ئېتىك</label>
          </template>
        </el-table-column>
        <el-table-column label="مەشغۇلات" prop="dosome" width="300">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              v-if="pageTags.update"
              @click="handleEdit(scope.$index, scope.row)">تەھرىرلەش </el-button>
            <el-button
              size="mini"
              type="danger"
              v-if="pageTags.delete"
              @click="handleDelete(scope.$index, scope.row)">ئۆچۈرۈش </el-button>
          </template>
        </el-table-column>
      </el-table> 
    </div>

    <!-- el-dialog -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="65%"
      top="3vh"
      :before-close="handleClose">
      <div class="rtl-right form-content">
        <el-form label-width="120px" :model="ruleForm" ref="ruleForm">
          <el-form-item label="رەسىم" prop="image">
            <el-upload
              class="avatar-uploader"
              :action="imgActionUrl"
              name="image"
              :data="imageData"
              :headers="imageHeader"
              :on-error="handleImageError"
              :on-success="handleImageSuccess">
              <img v-if="ruleForm.image" :src="ruleForm.image" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="ئوقۇتقۇچى (ئۇيغۇرچە)" prop="name_ug">
            <el-input v-model="ruleForm.name_ug" placeholder="ئوقۇتقۇچى (ئۇيغۇرچە)"></el-input>
          </el-form-item>
          <el-form-item label="ئوقۇتقۇچى (خەنزۇچە)" prop="name_zh">
            <el-input v-model="ruleForm.name_zh" class="ltr-left" placeholder="期限（中文）"></el-input>
          </el-form-item>
          <el-form-item label="تېلېفون" prop="phone">
            <el-input type="number" v-model="ruleForm.phone" class="ltr-left" placeholder="تېلېفون"></el-input>
          </el-form-item>
          <el-form-item label="پىرسەنت 1" prop="percent">
            <el-input type="number" v-model="ruleForm.percent" class="ltr-left" placeholder="باشقىلار دەرس ساتقاندىكى پىرسەنت"></el-input>
          </el-form-item>
          <el-form-item label="پىرسەنت 2" prop="own_percent">
            <el-input type="number" v-model="ruleForm.own_percent" class="ltr-left" placeholder="ئوقۇتقۇچى ئۆزى ساتقاندىكى پىرسەنت"></el-input>
          </el-form-item>
          <el-form-item label="تەرتىپى" prop="order">
            <el-input type="number" v-model="ruleForm.order" class="ltr-left" placeholder="تەرتىپى"></el-input>
          </el-form-item>
          <el-form-item label="چۈشەندۈرلىشى (ئۇيغۇرچە)" prop="description_ug" class="ltr-left">
            <vue-ueditor-wrap v-model="ruleForm.description_ug" :config="myConfig"></vue-ueditor-wrap>
          </el-form-item>
          <el-form-item label="چۈشەندۈرلىشى (خەنزۇچە)" prop="description_zh" class="ltr-left">
            <vue-ueditor-wrap v-model="ruleForm.description_zh" :config="myConfig"></vue-ueditor-wrap>
          </el-form-item>
          <el-form-item label="تەسىيە" prop="recommend" class="radio-form">
            <el-radio v-model="ruleForm.recommend" label="1">ھەئە</el-radio>
            <el-radio v-model="ruleForm.recommend" label="0">ياق</el-radio>
          </el-form-item>
          <el-form-item label="ھالەت" prop="status" class="radio-form">
            <el-radio v-model="ruleForm.status" label="1">ئوچۇق</el-radio>
            <el-radio v-model="ruleForm.status" label="0">ئېتىك</el-radio>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" plain @click="submitForm('ruleForm')">مۇقىملاش</el-button>
        <el-button type="warning" plain @click="resetForm('ruleForm')">ئەسلىگە قايتۇرۇش</el-button>
        <el-button type="danger" plain @click="closeDialog('ruleForm')">بىكار قىلىش</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<style lang="scss" scoped>
  .avatar-uploader{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 150px;
    height: 150px;
    img{
      width: 150px;
      height: 150px;
    }
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 24px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .table-img{
    width: 80px;
    height: 80px;
    border-radius: 5px;
    border: 1px solid #EBEEF5;
  }
  .mytitle{
    color: #909399;
    font-size: 14px;
    padding-bottom: 10px;
  }
  .mycontent{
    direction: initial;
    text-align: initial;
    text-align: justify;
    line-height: 1.5rem;
  }
  .mytitle-ug,.mycontent-ug{
    direction: rtl;
    text-align: right;
  }
  .mytitle-zh{
    direction: ltr;
    text-align: left;
  }
</style>

<script>
  var self;

  import baseConfig from '../base.config.js'
  var home_url = baseConfig.baseUrl + 'editor/controller.php';
  import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module

  export default {
    activated: function() {
      self = this;
      self.getList();
      self.imgActionUrl = baseConfig.imgActionUrl;
    },
    data() {
      return {
        tableData: [],
        loading: false,
        dialogVisible: false,
        ruleForm: {
          image: "",
          name_ug: "",
          name_zh: "",
          phone:"",
          percent:"",
          own_percent:"",
          order:"",
          description_ug:"",
          description_zh:"",
          recommend:"1",
          status: "1"
        },
        editIndex: -1,
        dialogTitle:"",
        addDialog:true,
        editId:"",
        pageTags:{},
        imgActionUrl:"",
        imageData:{
          "folder":"test"
        },
        imageHeader:{
          'Authorization': 'Bearer ' + localStorage.getItem("token"),
          'X-Requested-With': 'XMLHttpRequest'
        },
        myConfig: {
          // 编辑器不自动被内容撑高
          autoHeightEnabled: false,
          // 初始容器高度
          initialFrameHeight: 500,
          // 初始容器宽度
          initialFrameWidth: '100%',
          // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
          // serverUrl: 'http://35.201.165.105:8000/controller.php',
          // serverUrl: 'https://durdana-api.hamdam.biz/editor/controller.php',
          serverUrl: home_url,
          // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
          UEDITOR_HOME_URL: '/UEditor/'
        }
      };
    },
    methods: {
      getList() {
        self.loading = true;
        self.$fetch("admin/teacher").then(response => {
          if (response.status == 200) {
           self.tableData = response.data.data;
          } else{
            console.log(response.message);
          }

          self.loading = false;
          if(JSON.parse(sessionStorage.getItem("curTags"))){
            self.pageTags = JSON.parse(sessionStorage.getItem("curTags"));
          }
        }).catch(err => {
          console.log('××××××××××××××');
          console.log(err);
          self.loading = false;
        });
      },
      add() {
        self.addDialog = true;
        self.dialogTitle = "قوشۇش";
        self.dialogVisible = true;
      },
      handleEdit(index, row) {
        self.addDialog = false;
        self.dialogTitle = "تەھرىرلەش";
        self.editId = row.id;
        self.ruleForm.image = row.image;
        self.ruleForm.name_ug = row.name_ug;
        self.ruleForm.name_zh = row.name_zh;
        self.ruleForm.phone = row.phone;
        self.ruleForm.percent = row.percent;
        self.ruleForm.own_percent = row.own_percent;
        self.ruleForm.order = row.order;
        self.ruleForm.description_ug = row.description_ug;
        self.ruleForm.description_zh = row.description_zh;
        self.ruleForm.recommend = row.recommend + '';
        self.ruleForm.status = row.status + '';
        self.dialogVisible = true;
      },
      handleDelete(index, row) {
        self.$confirm("ئۆچۈرۈشنى مۇقۇملامسىز ؟", "ئەسكەرتىش", {
          confirmButtonText: "مۇقىملاش",
          cancelButtonText: "بىكار قىلىش",
          type: "warning"
        }).then(() => {
          self.$remove('admin/teacher/'+row.id).then((response) => {
            console.log(response);
            if(response.status == 204){
              self.getList();
              self.$message({
                message: "ئۆچۈرۈش تاماملاندى",
                type: "success",
                duration: 1200
              });
            }else{
              console.log(response);
            }
          }).catch(err => {
            console.log('××××××××××××××××');
            console.log(err);
          });

        }).catch(() => {
          self.$message({
            type: "info",
            message: "ئۆچۈرۈش بىكار قىلىندى"
          });
        });
      },
      submitForm(formName) {
        var myData = {
          image: self.ruleForm.image,
          name_ug: self.ruleForm.name_ug,
          name_zh: self.ruleForm.name_zh,
          phone:self.ruleForm.phone,
          percent:self.ruleForm.percent,
          own_percent:self.ruleForm.own_percent,
          order:self.ruleForm.order,
          description_ug: self.ruleForm.description_ug,
          description_zh: self.ruleForm.description_zh,
          recommend:self.ruleForm.recommend,
          status: self.ruleForm.status
        }

        if(self.addDialog){
          self.$post('admin/teacher',myData).then((response) => {
            if(response.status == 201){
              self.closeDialog(formName);
              self.getList();
              self.$message({
                message: response.data.message,
                type: "success",
                duration: 1200
              });
            }else{
              console.log(response.data.message);
            }
          }).catch(err => {
            console.log('××××××××××××××');
            console.log(err);
          });
        }else{
          self.$put('admin/teacher/'+self.editId,myData).then((response) => {
            if(response.status == 201){
              self.closeDialog(formName);
              self.getList();
              self.$message({
                message: response.data.message,
                type: "success",
                duration: 1200
              });
            }else{
              self.$message({
                message: response.data.message,
                type: "warning",
                duration: 1500
              });
            }
          }).catch(err => {
            console.log('××××××××××××××');
            console.log(err);
          });
        }
      },
      resetForm(formName) {
        self.$refs[formName].resetFields();
        self.ruleForm = {
          image: "",
          name_ug: "",
          name_zh: "",
          phone:"",
          percent:"",
          own_percent:"",
          order:"",
          description_ug: "",
          description_zh: "",
          recommend:"1",
          status: "1"
        }
      },
      closeDialog(formName) {
        self.resetForm(formName);
        self.dialogVisible = false;
      },
      handleClose(done) {
        done();
        self.resetForm("ruleForm");
      },
      handleImageSuccess(res, file) {
        self.ruleForm.image = res.data.image;
      },
      handleImageError(err,file){
        var uploadErr = JSON.parse(err.toString().replace('Error:',''));
        self.$message({
          message: uploadErr.message,
          type: 'warning'
        });
      },
    },
    components: {
      VueUeditorWrap
    }
  };
</script>
